export default {
    app: {
        actions: {
            add: 'toevoegen',
            addAndNew: 'nieuw >>',
            cancel: 'annuleren',
            ok: 'ok',
            save: 'opslaan',
            saveContinue: 'opslaan en dooorgaan >>',
            download: 'download',
            edit: 'wijzigen',
            upload: 'uploaden'
        },
        underConstruction: 'Deze website is "under construction."',
        applicationName: 'Chess Administrator',
        menu: {
            tournaments: 'toernooien',
            clubs: 'clubs',
            chessPlayers: 'schakers',
            login: 'inloggen',
            logout: 'uitloggen',
            merchandise: 'Nieuw: support de site, koop merchandise!'
        },
        footer: {
            copyright: 'copyright',
            termsAndConditions: 'algemene voorwaarden',
            privacyStatement: 'privacy statement',
            contact: 'contact',
            about: 'info'
        }
    },
    contact: {
        contactIntro: 'Je kunt hieronder een bericht achterlaten voor de ontwikkelaar van deze website. We horen graag wat er goed is of wat er beter kan. ',
        email: 'jouw e-mailadres',
        remarks: 'plaats je opmerkingen hier',
        robotSecure: 'robot check',
        robotTextFinish: ' wint.',
        robotTextStart: 'wit begint en ',
        send: 'versturen',
        sendSucces: 'feedback succesvol verzonden, bedankt!'
    },
    dashboard: {
        freeSubscription: 'Wordt gratis lid',
        adText: 'Organiseer eenvoudig online <br/>je clubcompetitie of schaaktoernooi',
        involvement: 'activiteit',
        recentlyVisited: 'recent bezocht',
        notOrganizing: 'Je organiseert op dit moment geen toernooien',
        notParticipating: 'Je neemt niet deel aan lopende toernooien',
        notMember: 'Je bent geen lid van een club',
        menu: {
            defaultInfo: 'Vind toernooien, zoek een club, of bekijk je favoriete spelers',
            tournamentsInfo: 'Een overzicht van lopende toernooien en toernooiuitslagen',
            clubsInfo: 'Bekijk welke clubs er zijn en welke toernooien ze organiseren, wie er spelen etc.',
            chessPlayersInfo: 'Per speler kun je zien welke toernooien zijn gespeeld en wat de uitslagen waren'
        },
        search: 'zoek naar toernooien, spelers of clubs',
        siteExplanation: {
            title: 'Waarom lid worden?',
            unregistered: 'Als ongeregistreerde gebruiker kun je op schaaktoernooien.nl uitslagen bekijken van gespeelde competities. ' +
                'Gratis registreren heeft diverse voordelen:',
            personalPage: {
                title: 'Persoonlijke pagina\'s',
                text: 'Voor een mooi overzicht van je eigen uitslagen en lopende toernooien.'
            },
            knsbConnection: {
                title: 'Koppeling met KNSB gegevens',
                text: 'Door je account te koppelen aan een speleraccount van de KNSB, heeft een organisator direct jouw benodigde ' +
                    'gegevens als je je via schaaktoernooien.nl aanmeldt voor een toernooi.'
            },
            tournamentByes: {
                title: 'Aan- en afmelden',
                text: 'Je kunt je via deze site aanmelden of afmelden voor bepaalde ronden in een toernooi. De organisator is ' +
                    'daarmee automatisch op de hoogte.'
            },
            notifications: {
                title: 'Notificaties',
                text: 'Ontvang berichten als er een indeling is gemaakt of gewijzigd zodat je weet tegen wie je speelt.'
            },
            organize: {
                title: 'Organiseer je eigen toernooi!',
                text: 'Iedere gebruiker kan een eigen toernooi starten. Als club kun je je interne competitie bijhouden, als ' +
                    'toernooiorganisatie kun je ook grote toernooien registreren in dit systeem. Organiseer je thuis een ' +
                    'toernooitje, dan kun je snel het speelschema laten genereren.'
            }
        },
    },
    group: {
        addGroup: 'groep toevoegen',
        editGroup: 'groep wijzigen'
    },
    management: {
        playerImport: 'speler import',
        importStatus: 'de import van spelers is gestart. Hier is enkele minuten geduld voor nodig. De status:'
    },
    match: {
        blackPlayer: 'achter de zwarte stukken',
        fix: '(ver/ont)grendel deze partij', 
        result: 'resultaat',
        selectPlayer: 'selecteer een speler',
        whitePlayer: 'achter de witte stukken'
    },
    round: {
        addRound: 'ronde toevoegen',
        date: 'datum (dd-mm-jjjj)',
        editRound: 'ronde wijzigen',
        noRounds: 'er zijn geen ronden aangemaakt'
    },
    registration: {
        absent: 'absent',
        addRegistrations: 'speler(s) toevoegen',
        available: 'aanwezig',
        availability: 'std aanwezigheid',
        availabilityExplanation: 'aanwezigheid die wordt ingevuld voor nieuwe ronden',
        deletePlayer: 'verwijder deze speler',
        editPlayer: 'wijzig deze speler',
        estimatedELO: 'geschatte rating',
        federationNumber: 'bondsnummer',
        federationPlayer: 'bondsspeler',
        loading: 'spelers worden geladen...',
        name: 'naam',
        newPlayer: 'nieuwe speler',
        playerType: 'soort speler',
        residence: 'woonplaats',
        selectClub: 'selecteer een club',
        updateRegistration: 'spelergegevens aanpassen'
    },
    tournament: {
        absenceAddedAs: ' toegevoegd als ',
        absenceReason: 'reden voor afwezigheid',
        addAbsence: 'voeg een speler toe als afwezige',
        addGroup: 'groep toevoegen',
        addMatch: 'partij toevoegen',
        addPlayer: 'speler toevoegen',
        calculate: 'berekenen',
        createPairing: 'genereer indeling',
        createStaticSite: 'creëer statische website',
        deleteGroup: 'verwijder deze groep',
        deleteTournament: 'verwijder dit toernooi',
        description: 'extra beschrijving',
        details: 'toernooigegevens',
        editMatch: 'partij wijzigen',
        editTournament: 'wijzig toernooi details',
        edition: 'editie',
        entry: 'inschrijving',
        extraNotes: 'toelichting op het toernooi',
        finishRound: 'afsluiten ronde',
        from: 'vanaf',
        fromRound: 'eerste ronde voor rapport',
        generalInformation: 'algemeen',
        location: 'locatie',
        management: 'overig beheer',
        managers: 'toernooi managers',
        managersText: 'hier worden alle toernooi managers getoond. je kunt andere personen toevoegen om ook dit toernooi te kunnen beheren.',
        notifications: 'notificaties',
        nopairing: 'er zijn geen partijen ingedeeld',
        noPlayerSelected: 'geen speler geselecteerd',
        noReasonSelected: 'geen reden geselecteerd',
        organisingMyself: 'persoonlijke organisatie',
        organizer: 'organisator',
        pairing: 'indeling',
        pairingApproved: 'indeling akkoord',
        pairingAndScoring: 'paring en scores',
        pairingSystem: 'indeling',
        period: 'periode',
        player: 'speler', 
        playerResults: 'resultaten speler',  
        ratingReport: 'rating rapportage',
        reopenRound: 'heropenen ronde',
        reportText: 'chess administrator kan een rating rapportage in FIDE format leveren, wat door de meeste bonden wordt geaccepteerd. ' +
                       'creëren en downloaden zal beginnen wanneer u op de "download" knop klikt.',
        resultUpload: 'upload resultaten via SFTP',
        scoring: 'scores',
        selectFromRound: 'selecteer de 1e ronde om te rapporteren',
        selectUntilRound: 'selecteer de laatste ronde om te rapporteren',
        sftpKeyfile: 'SFTP key',
        sftpLocation: 'SFTP locatie',
        sftpPassword: 'wachtwoord',
        sftpUser: 'gebruikersnaam',
        selectType: 'selecteer het type toernooi',
        tempo: 'speeltempo',
        tournament: 'toernooi',
        until: 't\\m',
        untilRound: 'laatste ronde voor rapport',
        upload: 'upload',
        uploadExplanation: 'voor het maken van statische html pagina\'s, die kunnen worden getoond op de website van je club',
        youAreManager: 'je bent de toernooi beheerder',
        youAreParticipant: 'je neemt / nam deel aan dit toernooi',
        selectManager: {
            add: 'manager toevoegen',
            header: 'manager toevoegen',
            select: 'selecteren'
        }
    },
    tournaments: {
        actions: 'acties',
        absences: 'absenties',
        absence: 'absentie',
        B: 'z',
        bTitle: 'aantal partijen met zwart',
        create: 'nieuw toernooi',
        draw: '½',
        drawTitle: 'aantal partijen remise',
        elo: 'elo',
        eloTitle: 'ELO rating',
        entryForm: 'deelname formulier',
        found: 'gevonden toernooien',
        group: 'groep',
        lost: '0',
        lostTitle: 'aantal verloren partijen',
        match: 'partij',
        matches: 'partijen',
        name: 'naam',
        noAbsences: 'er zijn geen afmeldingen deze ronde',
        nopairing: 'geen indeling bekend voor deze ronde',
        noplayers: 'nog geen spelers beschikbaar in deze groep',
        points: 'punten',
        pointsTitle: 'puntentotaal, 1 voor winst, ½ voor remise, bevat ook absentie scores',
        reason: 'reden',
        registrations: 'aanmeldingen',
        results: 'resultaten',
        round: 'ronde',
        rounds: 'ronden',
        sb: 'sb',
        sbTitle: 'Sonneborn-Berger score',
        score: 'score',
        search: 'zoek toernooi',
        standings: 'stand na ronde',
        tpr: 'tpr',
        tprGain: 'tpr stijging',
        tprGainTitle: 'TPR gerelateerd aan begin ELO dit toernooi',
        tprStandings: 'TPR klassement na ronde',
        tprTitle: 'toernooi prestatie rating',
        value: 'waarde',
        valueTitle: 'je Keizer Waarde, per ronde bepaald adhv de stand',
        W: 'w',
        wp: 'wp ',
        wpTitle: 'weerstandspunten',
        won: '1',
        wonTitle: 'aantal gewonnen partijen',
        wTitle: 'aantal partijen met wit'
    },
    settings: {
        settings: 'instellingen',
        userSettings: 'gebruiker',
        userAccount: 'extern account',
        username: 'login naam',
        linkedTo: 'account gelinkt aan',
        moreInfo: 'meer informatie',
        notLinked: 'niet gekoppeld',
        account: 'account',
        linkToAccount: 'koppelen',
        linkToOtherAccount: 'koppeling aanpassen',
        password: 'wachtwoord',
        interface: 'scherm',
        language: 'taal',
        theme: 'thema'
    },
    sftp: {
        host: 'host',
        noHost: 'geen host ingevuld',
        noTargetLocation: 'doelmap niet ingevuld',
        noUser: 'gebruiker niet ingevuld',
        uploadTitle: 'upload statische html naar je eigen website (sftp)',
        username: 'gebruikernaam',
        password: 'wachtwoord',
        targetLocation: 'doelmap op ftp server',
        uploadInProgress: 'uploaden loopt, graag even geduld'
    },
    signin: {
        confirmationNeeded: 'je e-mailadres moet geverifieerd zijn voordat je kunt inloggen. check je e-mail aub.',
        confirmationNotReceived: 'ik heb geen verificatiemail ontvangen',
        confirmationResend: 'ik denk dat ik nog een verificatiemail nodig heb',
        confirmationSucces: 'je email is succesvol geverifieerd. je kunt nu inloggen met je aangemaakte credentials',
        loginFailed: 'login mislukt',
        username: 'gebruikernaam',
        password: 'wachtwoord',
        forgotPassword: 'wachtwoord vergeten?',
        requestPassword: 'nieuw wachtwoord aanvragen',
        requestPasswordButton: 'nieuw wachtwoord',
        passwordResetMsgSent: 'we hebben een e-mail gestuurd met een link, waarmee je je wachtwoord kunt aanpassen.',
        passwordResetMessage: 'je wachtwoord is succesvol vastgelegd. je kunt nu inloggen op ChessAdministrator met je nieuwe gegevens.',
        sessionTimedOut: 'je sessie is na verloop van tijd automatisch verlopen. je probeerde een actie uit te voeren waarvoor je ingelogd moet zijn. log opnieuw in en probeer het daarna opnieuw.',
        createAccount: 'account aanmaken',
        waitingForConfirmation: 'Bedankt voor je inschrijving. Bevestig je e-mail via de link die we je zojuist per mail gestuurd hebben. Daarna kun je inloggen en aan de slag!',
        welcome: 'Welkom bij Chess Administrator. Login om je in te schrijven voor een toernooi, of organiseer je eigen toernooi!'
    },
    signup: {
        accountAvailable: 'al een account?',
        confirmationSucces: 'de e-mail verificatie is gelukt. je kunt nu inloggen om de volledige functionaliteit van ChessAdministrator te ervaren.',
        containsCapital: 'bevat een hoofdletter',
        containsLowercase: 'bevat een kleine letter',
        containsNumber: 'bevat een getal',
        eightCharacters: 'tenminste 8 karakters',
        onlyCharactersAndDigits: 'bevat alleen letters en cijfers',
        forgotPasswordText: 'Wanneer je je wachtwoord vergeten bent, kun je een nieuwe aanvragen. Vul je gebruikersnaam in (ook te vinden in je welkomst e-mail) en je ontvangt instructies per mail.',
        fourCharacters: 'tenminste 4 karakters, geen spaties',
        passwordsEqual: 'wachtwoorden komen overeen',
        register: 'aanmelden',
        sideText: 'Maak een account aan om mee te spelen met toernooien of zelf toernooien te organiseren.',
        validEmail: 'geldig e-mail adres',
        emailConfirmation: 'e-mail bevestiging',
        confirmationWaiting: 'je hebt de e-mail link gebruikt die we je gestuurd hebben. De verificatie wordt nu uitgevoerd.',
        toSignin: 'naar login',
        confirmationNotReceivedheader: 'bevestigingsmail niet ontvangen?',
        confirmationResendInformation: 'om in te loggen in ChessAdministrator moet je e-mailadres geverifieerd zijn. heb je deze mail niet binnen een kwartier ontvangen, of is de link verlopen, vul dan je e-mail adres in en klik op "opnieuw verzenden" om de mail opnieuw te laten versturen.',
        resend: 'opnieuw versturen'
    },
    beta: {
        chessAdministratorBeta: 'Chess Administrator bèta',
        paragraph1: 'Er wordt nog hard gewerkt aan deze website. De functionaliteit wordt gebruikt door onze lokale schaakclub en daarmee live getest. Je kunt de applicatie op eigen risico gebruiken, er worden geen garanties gegeven over functionaliteit en beschikbaarheid tot de eerste officiële release. (maar begrijp dat we zelf inmiddels afhankelijk zijn van deze site). De huidige functionaliteit kan nog wijzigen.',
        paragraph2: 'We nodigen je van harte uit om feedback te geven op het Chess Administrator programma. Probeer zoveel mogelijk een reproductie scenario te vermelden bij het melden van een issue. Functionele wensen en eisen zullen worden overwogen en worden op de backlog geplaatst. In de eerste plaats willen we de website zo schoon en overzichtelijk mogelijk houden, waardoor secondaire opties mogeijk beperkt blijven. We focussen op gebruikerservaring en -gemak en het leveren van een zo goed en stabiel mogelijk administratiesysteem.',
        paragraph3: 'Veel plezier met het gebruik van deze site! (en overweeg een donatie ;-))',
        paragraph4: 'Chess Administrator, sinds 2022'
    },
    clubs: {
        search: 'zoek club',
        federation: 'bond',
        found: 'gevonden clubs',
        code: 'code',
    },
    person: {
        noClub: 'geen clublid',
        tournament: 'toernooi',
        rank: 'plek',
        rating: 'rating',
        ratingDifference: 'verschil',
        ratingList: 'ratinglijst',
        score: 'score',
        tpr: 'tpr',
        outOf: 'out of'
    },
    selectUser: {
        filterClub: 'club filter',
        impersonationFailed: 'Koppeling mislukt. De gekozen persoon is al gelinkt aan een ander account. Ben jij dit echt? Neem dan contact op met de beheerder van de site.',
        join: 'Join the club!',
        link: 'koppelen',
        moreInfo: 'meer informatie over deze koppeling',
        noMember: 'ik ben geen lid van een schaakclub',
        player: 'speler',
        selectYourself: 'selecteer jezelf',
        sideText: 'Je hebt succesvol een account aangemaakt. Om nog efficiënter gebruik te kunnen maken van diverse opties, raden we je aan je account te koppelen aan een Federatie account.',
        thisIsMe: 'dit ben ik'
    },
    persons: {
        code: 'code',
        federation: 'bond',
        federationNumber: 'bondsnummer',
        found: 'gevonden personen',
        latestRanking: 'huidige rating',
        noRunningTournaments: 'geen lopende toernooien op dit moment',
        noTournamentsPlayed: 'deze persoon heeft geen eerdere toernooien gespeeld via chess administrator',
        outOf: 'van de',
        rating: 'rating',
        search: 'zoek speler'
    },
    info: {
        about: {
            heroTitle: 'Chess Administrator. Jouw complete schaakwereld, georganiseerd',
            heroSubtitle: 'Van toeschouwer naar organisator. Ontdek het platform dat met je meedenkt.',
            signUpAndStart: 'Word gratis lid & start direct',
            justGo: 'gewoon door naar de site >>',
            moreThanJustResults: 'Meer dan alleen uitslagen bekijken',
            more1: 'Als bezoeker zie je wat er gebeurd is. Als lid bepaal je wat er gaat gebeuren. Registreren is gratis en opent de deur naar een meer persoonlijke ervaring en mogelijkheden om zelf te organiseren. En in alle gevallen: geen advertenties, geen trackers.',
            yourChessCareer: 'Jouw schaakcarrière in beeld',
            career1: 'Al je uitslagen, ratingverloop en aankomende toernooien op één centraal dashboard. Koppel eenvoudig je account aan je KNSB ID zodat organisatoren direct over de juiste gegevens beschikken.',
            neverMissAMove: 'Mis nooit meer een zet',
            miss1: 'Meld je eenvoudig aan of af voor toernooironden met één klik. Ontvang direct een notificatie zodra de indeling bekend is en wanneer de uitslagen bekend zijn.',
            organizeProfessional: 'Organiseer professioneel',
            organize1: 'Iedere gebruiker kan een eigen toernooi starten. Houd je interne clubcompetitie bij of registreer grote evenementen in dit systeem. Genereer razendsnel je speelschema voor Keizer of Zwitsers. ',
            readyToMakeYourMove: 'Klaar om de eerste zet te doen?',
            memberLoginHere: 'Al lid? Log hier in',
            goToStart: 'Ga door naar de startpagina',
            createFreeAccount: 'Maak nu je gratis account aan'
        },
        donate: {
            header: 'doneren',
            intro: 'Hou je ervan om Chess Administrator te gebruiken?',
            paragraph1: 'Overweeg dan een donatie!',            
            paragraph2: 'Chess Adminstrator wordt gemaakt door enthousiastelingen, met als doel het organisatoren zo makkelijk mogelijk te maken en spelers zo goed mogelijk geïnformeerd te houden over hun deelnames.',
            paragraph3: 'Het avond- en weekend werk is er met liefde ingestopt. Je kan gratis gebruik maken van die arbeid, gedreven door zwarte koffie, wat blond bier en ontspannende fietsritten door de mooie polders van Nederland.',
            paragraph4: 'De serverkosten, domeinregistratie etc. zijn echter terugkerende kosten. Een paar euro per jaar kan een gemiddelde club best dragen, toch? Een kleine vergoeding zou dan ook erg worden gewaardeerd! Ook inspireert dat het verder ontwikkelen en verbeteren van de website.',
            paragraph5: 'Donaties kunnen worden gedaan via "Buy me coffee", te benaderen via onderstaande knop.'                
        },
        linkingAccount: {
            header: 'koppelen van je account',
            intro: 'je kunt via het programma een bij de KNSB bekend lidmaatschap selecteren, om aan te geven dat jij dat bent. Dit heeft een aantal voordelen.',
            maybeNextTime: 'misschien een volgende keer',
            yesIWill: 'ja, ik wil mijn account linken',
            advantage1Title: 'Aanmeldingen',
            advantage1Text: 'Wanneer je je aanmeld voor een toernooi via Chess Administrator, zijn daardoor bij de organisatie direct alle benodigde gegevens beschikbaar om je op te nemen in het toernooi. Uitslagen kunnen hiermee makkelijker worden verstuurd naar de KNSB voor ratingverwerking.',
            advantage2Title: 'Organisatie',
            advantage2Text: 'Bij het organiseren van een toernooi zal het programma er vanuit gaan dat je dat doet voor de club waar je bij aangesloten bent. Hierdoor kun je gemakkelijker andere leden van je club uitnodigen en toevoegen.',
            advantage3Title: 'Verkeerd geselecteerd?',
            advantage3Text: 'Heb je per ongeluk een verkeerde persoon geselecteerd dan kun je dit altijd nog herstellen via de menuoptie "settings", wanneer je rechts bovenin op je naam klikt. Misbruik van deze optie om express andere personen te selecteren wordt bestraft met het bannen van het account.'
        },
        version: {
            header: 'Versie informatie',
            intro: 'Deze pagina toont de versie informatie van Chess Administrator. Alle beschikbare functionaliteit op een rijtje, met ook nog wat wensen die op de lijst staan om geïmplementeerd te worden.',
            beta: 'Beta',
            betaIntro: 'Deze versie draaide van 2022 tot en met 2025. In de loop van de tijd zijn hier uitbreidingen op toegevoegd, die inmiddels allemaal ruim getest en beschikbaar zijn.',
            beta1: 'Gebruikers registratie',
            beta2: 'Toernooi organisatie',
            beta3: 'Indeling op basis van systeem Keizer',
            beta4: 'E-mailnotificatie naar geregistreerde gebruikers, met uitslagen en indelingen',
            beta5: 'Actuele KNSB gegevens voor het gemakkelijk toevoegen van deelnemers met de juiste gegevens (ID, actuele rating)',
            beta6: 'Meerdere groepen per toernooi',
            beta7: 'Export van FIDE rapportage ten behoeve van ratingverwerking',
            bastion: 'Bastion 1.0',
            bastionIntro: 'Deze versie is beschikbaar vanaf 1-1-2026. Het stadium Beta is daarmee voorgoed voorbij. Deze versie heeft een nieuwe lik verf gekregen voor een strakker en serieuzer uiterlijk wat past bij de degelijkheid die je wilt hebben van een indelingsprogramma. Onder de motorkap is één en ander flink gewijzigd:',
            bastiont1: 'Een nieuwe database, waarmee de toekomst van dit programma beter wordt geborgd',
            bastiont2: 'Aparte Test- en Productieomgeving',
            bastiont3: 'Vernieuwde e-mail verzenddienst',
            bastiont4: '.Net Framework geupdated',
            bastiont5: 'Officiële domeinnaam registratie',
            bastiont6: 'Aanpassingen voor up-to-date ratingimport',
            bastionFunctionalImprovements: 'Functionele uitbreidingen zijn er ook:',
            bastionf1: 'Zwiterse indeling (onderdeel nog in Beta)',
            bastionf2: 'Splashscreen met informatie',
            bastionf3: 'Diverse kleinere aanpassingen: verbeterde sorteringen, button werking',
            bastionf4: 'Unit tests op de indelingsalgorithmes',
            bastionf5: 'Refresh tokens, om de verbinding te behouden, ook wanneer je een hele avond uitslagen wilt invullen',
            bastionf6: 'En, niet direct functionaliteit van deze site, maar wel leuk: een merchandise site',
            improvements: 'Enkele verbeterpunten die bekend zijn, waaraan nog wordt gewerkt:',
            improvement1: 'Management opties zijn verdwenen na het aanaken van een nieuw toernooi',
            improvement2: 'Actieve ronde resultaten tonen bij het openen van een toernooi'
        },
    },
    changePassword: 'wijzig wachtwoord',
    login: 'login'
};
